/**
 * PrevCalifications Component
 *
 * Features:
 * - Displays a paginated table of previous quiz califications.
 * - Uses i18next for translations.
 * - Handles pagination and row display logic.
 * - Receives califications array as prop.
 */
import { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
// import classes from './PrevCalifications.module.css';

const PrevCalifications = props => {
  const { t } = useTranslation(['lesson']);
  // State to store current page for pagination
  const [page, setPage] = useState(0);
  // State to store number of rows per page
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(event.target.value);
  };
  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="left">
                {t('evaluation_date')}
              </TableCell>
              <TableCell align="right">
                {t('qualification')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.califications
              .slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage
              )
              .map(calification => (
                <TableRow
                  key={calification.idApplication}
                  sx={{
                    '&:last-child td, &:last-child th': { border: 0 }
                  }}
                >
                  <TableCell align="left">
                    {calification.startTime}
                  </TableCell>
                  <TableCell align="right">
                    {calification.score}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5]}
          component="div"
          count={props.califications.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </>
  );
};

PrevCalifications.propTypes = {
  /**
   * Array of previous califications
   */
  califications: PropTypes.array
};

PrevCalifications.defaultProps = {
  califications: []
};

export default PrevCalifications;
